export default "__VITE_ASSET__DEuPqXqN__"